import { Component } from '@angular/core';

@Component({
  selector: 'usucampeao-cadastro-validado',
  templateUrl: './cadastro-validado.component.html',
  styleUrls: ['./cadastro-validado.component.scss'],
})
export class CadastroValidadoComponent { }
